export default {
  title: 'Impressum',
  subtitle:
    'Pas de gegevens aan die worden weergegeven in het Impressum van uw winkel zonder uw bedrijfsprofiel te wijzigen.',
  defaultsNotice:
    'Elk veld is optioneel. Laat een veld leeg om de waarde uit uw bedrijfsprofiel te blijven gebruiken — de huidige standaard wordt grijs weergegeven als voorbeeld. Een veld invullen overschrijft alleen het Impressum; uw bedrijfsprofiel blijft ongewijzigd.',
  fields: {
    legal_name: {
      label: 'Bedrijfs- / handelsnaam',
      placeholder: 'bijv. Musterbetrieb GmbH',
    },
    owner_first_name: {
      label: 'Voornaam eigenaar',
      placeholder: 'bijv. Alex',
    },
    owner_last_name: {
      label: 'Achternaam eigenaar',
      placeholder: 'bijv. Müller',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: 'bijv. info@example.com',
      invalid: 'Voer een geldig e-mailadres in',
    },
    owner_phone_number: {
      label: 'Telefoon',
      placeholder: 'bijv. +49 30 1234567',
    },
    tax_id: {
      label: 'Belastingnummer',
      placeholder: 'bijv. DE123456789',
    },
    address: {
      label: 'Adres',
      placeholder: 'Straat, postcode, plaats',
    },
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    saved: 'Impressum opgeslagen',
    failed: 'Impressum opslaan mislukt',
  },
};
